import { Asset, AssetState } from '@/api/generatedApi';
import { ReplaceAssetFileModal } from '@/components/modals/ReplaceAssetFileModal';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Button, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useState } from 'react';

export const ReplaceAssetFileButton = ({
  asset,
  variant = 'button',
  size = 'small',
  onReplaced,
}: {
  asset: Asset;
  variant?: 'button' | 'icon';
  size?: IconButtonProps['size'];
  onReplaced?: () => void;
}) => {
  const { permissions } = useGetCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!permissions.canUploadAssets) return;

  const isIndexing = asset.state === AssetState.Indexing;
  const tooltipTitle = isIndexing ? 'Replace File (asset is currently indexing)' : 'Replace File';

  return (
    <>
      {variant === 'button' ? (
        <Button
          onClick={() => setIsModalOpen(true)}
          startIcon={<UploadFileIcon />}
          size={size}
          disabled={isIndexing}
          data-testid={AssetPageObjectModel.ReplaceAssetFileButton}
        >
          Replace File
        </Button>
      ) : (
        <Tooltip title={tooltipTitle}>
          <span>
            <IconButton
              onClick={() => setIsModalOpen(true)}
              size={size}
              disabled={isIndexing}
              data-testid={AssetPageObjectModel.ReplaceAssetFileButton}
            >
              <UploadFileIcon sx={{ fontSize: '22px' }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <ReplaceAssetFileModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        asset={asset}
        onReplaced={onReplaced}
      />
    </>
  );
};
